import React from 'react';
import styles from './loadingspinner.module.scss';
import { ColorClassSuffix } from 'features/shared/enums/colorClassSuffix';
import { useTranslation } from 'react-i18next';

interface Props {
  inContainer?: boolean;
  useContainerBg?: boolean;
  sizeInRem?: number;
  spinnerType?: "border" | "grow";
  spinnerColor?: ColorClassSuffix;
  title?: string;
}

const LoadingSpinner = ({
  inContainer = true,
  useContainerBg = true,
  sizeInRem,
  spinnerType = "border",
  spinnerColor,
  title
}: Props) => {
  // helpers
  const getInlineStyle = () => {
    if (sizeInRem) {
      let inlineStyle:React.CSSProperties = {
        width: `${sizeInRem}rem`,
        height: `${sizeInRem}rem`
      };

      return inlineStyle;
    }
  }

  const getColorClass = () => {
    return spinnerColor ? ` text-${spinnerColor}` : "";
  }

  // spinner render
  // text "Loading..." je pro zvyseni pristupnosti (neni normalne videt)
  // pokud by jej bylo potreba prelozit muselo by se to vyresit primo v
  // komponente napr. pres switch s dostupnymi jazyky
  const renderSpinner = () => {
    return (
      <div className={`spinner-${spinnerType} ${styles.spinner}${getColorClass()}`} role="status" style={getInlineStyle()}>
        <span className="sr-only">Loading...</span>
      </div>
    );
  }

  const renderTitle = () => {
    if (title) {
      return (
        <div className="text-center mt-2">
          {title}
        </div>
      );
    }    
  }

  // render
  if (inContainer) {
    return (
      <div className={`${styles.container}${useContainerBg ? " " + styles.containerBg : ""}`}>
        <div className={styles.box}>
          {renderSpinner()}
          {renderTitle()}
        </div>
      </div>
    ) 
  } else if (title) {
    return (
      <div className="text-center">
        {renderSpinner()}
        {renderTitle()}
      </div>
    );
  } else {
    return renderSpinner();
  }
}

export default LoadingSpinner;
